module.exports = __webpack_public_path__ + "img/file.c97e236c.svg";